// This file is auto-generated, any changes you make may be overridden
// You should use src/mercuryWebCompat/pages/Treasury/Onboarding/utils.ts to access these values
import {type GeneratedCusip, type TreasuryOnboardingData} from './types'
import {Day} from '~/utils/Calendar'

export const generatedPortfolioData: Record<
  GeneratedCusip | '4812C2734',
  TreasuryOnboardingData
> = {
  // Morgan Stanley MULSX
  '617455696': {
    fundSize: `$11.2B`,
    maturity: `90 days`,
    netYieldPct: 4.454,
    grossYieldPct: 5.52,
    mercuryFeePct: 1.066,
    composition: [
      ['Commercial Paper', 36.06],
      ['Certificates of Deposit', 26.65],
      ['Corporate Notes', 20.45],
      ['Repurchase Agreements', 16.85],
    ],
    updatedAt: new Day(2024, 6, 17),
  },
  // Vanguard VUSXX
  '921932109': {
    fundSize: `$75.7 B`,
    maturity: `30 days`,
    netYieldPct: 4.214,
    grossYieldPct: 5.28,
    mercuryFeePct: 1.066,
    composition: [
      ['U.S. Treasury Bills', 98.8],
      ['U.S. Govt. Obligations', 1.2],
    ],
    updatedAt: new Day(2024, 6, 17),
  },
  // JPMorgan IJTXX
  '4812C2734': {
    fundSize: `$41.10B`,
    maturity: `49 days`,
    netYieldPct: 4.194,
    grossYieldPct: 5.26,
    mercuryFeePct: 1.066,
    composition: [
      ['U.S. Treasury Repurchase Agreement', 50.2],
      ['U.S. Treasury Debt', 49.8],
    ],
    updatedAt: new Day(2024, 6, 17),
  },
} as const
